module.exports = __webpack_public_path__ + "public/images/slider/nedbay.bc910808c343f1bfe003d1341a30a1bb.webp";